import { ViewModelFactoryParams } from '../../../../utils/ControlledComponent/ControlledComponent.types';
import { CalendarState } from '../../controller';
import { CalendarContext } from '../../../../utils/context/contextFactory';
import { getLocalTimezone } from '../../../../utils/dateAndTime/dateAndTime';
import { Optional } from '../../../../types/types';
import { MemoizedViewModalFactory } from '../viewModel';
import { BookingsSettings } from '@wix/ambassador-bookings-v2-bookings-settings/types';

export type TimezoneSelectionViewModel = {
  selectableTimezones: string[];
  selectedTimezone: string;
  timezoneLabel: string;
  timezoneLocale: string;
};

export const memoizedTimezoneSelectionViewModel: MemoizedViewModalFactory<
  Optional<TimezoneSelectionViewModel>
> = {
  dependencies: {
    state: ['selectedTimezone'],
  },
  createViewModel: createTimezoneSelectionViewModel,
};

export function createTimezoneSelectionViewModel({
  context,
  state,
}: ViewModelFactoryParams<
  CalendarState,
  CalendarContext
>): Optional<TimezoneSelectionViewModel> {
  const { selectedTimezone } = state;
  const { bookingsSettings, t, reportError, languageSettings } = context;

  const locale = languageSettings!.dateRegionalSettingsLocale!;

  try {
    const selectableTimezones = getSelectableTimezones(bookingsSettings);
    return {
      selectableTimezones,
      selectedTimezone: selectedTimezone!,
      timezoneLabel: t('app.timezone-selection.timezone-label'),
      timezoneLocale: locale,
    };
  } catch (e) {
    reportError(e as string | Error);
  }
}

function getSelectableTimezones(bookingsSettings: BookingsSettings): string[] {
  if (bookingsSettings.displayTimeZone?.customerCanChange) {
    return [
      bookingsSettings.siteProperties?.timeZone || '',
      getLocalTimezone(),
    ];
  }
  return [];
}
